import styled from 'styled-components'

export const DashboardHeaderContainer = styled.div.attrs({
})`
    min-height: 105px;
    width: 100%;

    background:#2f3d39;
    padding: 10px 25px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    @media(max-width: 767px){
        padding: 10px 12px;
        min-height: initial;
    }
`;

export const DashboardHeaderSide = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    position: relative;

    /* No celular: logo à esquerda (linha 1) e avatar à direita (linha 1);
       a barra de navegação cai para a linha 2 (ver DashboardHeaderNav). */
    @media(max-width: 767px){
        &:first-child{ order: 1; }
        &:last-child{ order: 2; margin-left: auto; }
    }
`;

export const DashboardHeaderSideMobile = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media(max-width: 399px){
        flex-direction: row;
        align-items: center;
        gap: 15px;
    }
`;

// Barra de navegação principal (Atividades | Idiomas | Bíblico).
// No celular ela ocupa uma linha inteira abaixo do logo, sempre visível.
export const DashboardHeaderNav = styled.nav.attrs({
})`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1;

    @media(max-width: 767px){
        order: 3;
        width: 100%;
        flex: initial;
        justify-content: space-between;
        gap: 6px;
        padding-bottom: 4px;
    }
`;

export const DashboardHeaderAction = styled.button.attrs({
    type: 'button',
})`
    background: ${ props => props.active ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.08)' };
    color: #fff;
    font-size: 16px;
    font-weight: ${ props => props.active ? 'bold' : '600' };
    border: 2px solid ${ props => props.active ? 'rgba(255,255,255,0.65)' : 'transparent' };
    border-radius: 14px;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    min-height: 48px;
    padding: 0 20px;

    cursor: pointer;
    touch-action: manipulation;
    transition: background 0.15s ease, transform 0.1s ease;

    &:hover{
        background: rgba(255,255,255,0.25);
    }
    &:active{
        transform: scale(0.97);
    }

    span{
        font-size: 20px;
    }

    @media(max-width: 767px){
        flex: 1;
        padding: 0 8px;
        font-size: 14px;
        min-height: 48px;
    }
`;

export const DashboardHeaderActionIcon = styled.img.attrs({
})`
    /* Altura FIXA (não %): evita o logo "inchar" e empurrar o avatar
       para outra linha no celular. */
    margin-right: 10px;
    height: 52px;
    width: auto;

    @media(max-width: 767px){
        height: 40px;
        margin-bottom: 0;
    }
    @media(max-width: 399px){
        height: 36px;
        margin-right: 6px;
    }
`;

export const DashboardHeaderHomeIcon = styled.img.attrs({
})`
    width: 32px;
    height: 32px;
    margin-right: 15px;
    cursor: pointer;
    filter: invert(1);
    transition: all 0.2s ease;

    &:hover{
        filter: invert(0.7);
        transform: scale(1.1);
    }

    @media(max-width: 399px){
        width: 24px;
        height: 24px;
        margin-right: 0;
    }
`;
